module.exports = __webpack_public_path__ + "img/undraw_account_re_o7id.803dcb49.png";